<h3 *ngIf="showTitle" class="title">{{dynForm?.formResult?.title}}</h3>
<app-dyn-form [isEditMode]="isEditable" #dynForm [key]="key" [model]="data" (isSubmitted)="isSubmitted.emit($event)"></app-dyn-form>